// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles_hero__57LEV","triangle":"styles_triangle__Td6L_","right":"styles_right__aUlTm"};